"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import _ from "underscore";
import DocumentTypeSetter from "./document_type_setter";
import WaitingSpinner from "../../components/waiting_spinner";
import DisablingButton from "../../components/disabling_button";
import GroupByAttachmentsButton from "./group_by_attachments_button";
import Api from "../../api/api";
import ReactUtils from "../../react_utils";
import { DocumentGroupingError } from "../data/types/Pb";
var bem = ReactUtils.makeBem("document-types");
function doesNotStartWithAllowedTypesTitle() {
  return "This group does not start with allowed types. Allowed types before the first carrier invoice are: Statement Invoice, Notice of Assignment, Funding Form, Internal Documents - Other";
}
function backToBackInvoiceTitle() {
  return "This group has 2 or more consecutive carrier invoices.";
}
function fixTypeSolution() {
  return "If a document type is incorrect, fix the document type.";
}
function groupByAttachmentsButton(props) {
  var _a;
  return /* @__PURE__ */ jsx(
    GroupByAttachmentsButton,
    {
      documentBatch: props.documentBatch,
      available: !!((_a = props.documentBatch) == null ? void 0 : _a.manual_attachment_grouping_available) && props.documentIndexerService._allDocumentsHaveGroups(),
      onGrouped: props.onGroupedByAttachments || function() {
      },
      onRefused: props.onGroupingByAttachmentsRefused || function() {
      }
    }
  );
}
function groupingErrorTitle(error) {
  const errorToTitle = {};
  errorToTitle[DocumentGroupingError.DocumentGroupingErrorBackToBackInvoices] = backToBackInvoiceTitle();
  errorToTitle[DocumentGroupingError.DocumentGroupingErrorDoesNotStartWithAllowedDocumentType] = doesNotStartWithAllowedTypesTitle();
  return errorToTitle[error];
}
function possibleGroupingFailures(props) {
  if (groupingErrorExists(props)) {
    return _.map(
      groupingErrors(props),
      (error) => groupingErrorDisplay(props, error)
    );
  }
}
function groupingErrors(props) {
  return _.uniq(
    _.flatten(
      _.map(documentsWithGroupingErrors(props), (d) => {
        return d.data["grouping_errors"] || [];
      })
    )
  );
}
function groupingErrorDisplay(props, error) {
  return /* @__PURE__ */ jsxs("div", { className: "alert-box--caution document-types__grouping-alert", children: [
    /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx("span", { className: bem("__grouping-error-title"), children: /* @__PURE__ */ jsx("b", { children: "Grouping Error:\xA0" }) }),
      groupingErrorTitle(error)
    ] }),
    /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx("span", { className: bem("__grouping-error-title"), children: /* @__PURE__ */ jsx("b", { children: "Possible Solutions:" }) }),
      possibleSolutions(props, error)
    ] })
  ] });
}
function possibleSolutions(props, error) {
  const errorToSolutions = {};
  errorToSolutions[DocumentGroupingError.DocumentGroupingErrorBackToBackInvoices] = backToBackInvoiceSolutions(props);
  errorToSolutions[DocumentGroupingError.DocumentGroupingErrorDoesNotStartWithAllowedDocumentType] = doesNotStartWithAllowedTypesSolutions(props);
  return errorToSolutions[error];
}
function doesNotStartWithAllowedTypesSolutions(props) {
  return /* @__PURE__ */ jsxs("ul", { className: bem("__solutions-list"), children: [
    /* @__PURE__ */ jsx("li", { children: fixTypeSolution() }),
    /* @__PURE__ */ jsx("li", { children: skipAutoGroupingSolutionText(props) })
  ] });
}
function backToBackInvoiceSolutions(props) {
  return /* @__PURE__ */ jsxs("ul", { className: bem("__solutions-list"), children: [
    /* @__PURE__ */ jsx("li", { children: "If there is a 2 page invoice, merge pages together." }),
    /* @__PURE__ */ jsx("li", { children: fixTypeSolution() }),
    /* @__PURE__ */ jsx("li", { children: skipAutoGroupingSolutionText(props) })
  ] });
}
function skipAutoGroupingSolutionText(props) {
  if (props.documentIndexerService._allDocumentsHaveGroups()) {
    return "If document types are correct, skip auto-grouping.";
  } else {
    return "If pages are out of order go on to manual grouping.";
  }
}
function documentsWithGroupingErrors(props) {
  if (props.documentBatch) {
    return _.filter(props.documentBatch.documents, (d) => {
      return (d.data["grouping_errors"] || []).length > 0;
    });
  } else {
    return [];
  }
}
function groupingErrorExists(props) {
  return documentsWithGroupingErrors(props).length > 0;
}
function shouldUpdateGrouping(props) {
  if (props.documentBatch) {
    const firstGroup = props.documentBatch.document_groups && props.documentBatch.document_groups[0];
    if (firstGroup) {
      return firstGroup.grouping_method !== "manual";
    } else {
      return false;
    }
  } else {
    return false;
  }
}
function groupsWereManuallyRegrouped(props) {
  var _a;
  const groups = props.model.groups;
  if (!groups) {
    return false;
  }
  return ["manual_regroup", "manual_rearrange"].includes(
    (_a = groups[0]) == null ? void 0 : _a.grouping_method
  );
}
export default class extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      updating: false,
      doctypeChanged: false,
      types: {},
      prevSelectedDocument: this.props.model.selectedDocument
    });
    __publicField(this, "mounted", false);
    __publicField(this, "selector", () => {
      return /* @__PURE__ */ jsx(
        DocumentTypeSetter,
        {
          document: this.props.model.selectedDocument,
          documentTypesTransformer: this.props.documentTypesTransformer,
          handleEnterPress: this.handleEnterPress,
          onTypeSet: this.typeWasSet
        }
      );
    });
    __publicField(this, "completionButtons", () => {
      if (this.props.autoSavingGroups) {
        return /* @__PURE__ */ jsx("button", { className: "button", disabled: true, children: "Auto-saving..." });
      }
      if (shouldUpdateGrouping(this.props)) {
        return /* @__PURE__ */ jsxs("span", { children: [
          this.updateGroupingButton(),
          this.possibleManualGroupingButton(),
          this.possibleSkipAutoGroupingButton()
        ] });
      } else {
        return this.doneButton();
      }
    });
    __publicField(this, "handleEnterPress", (suggestedType) => {
      if (shouldUpdateGrouping(this.props)) {
        var docs = this.props.model.allDocuments();
        var remaining = _.reject(docs, _.property("type"));
        if (remaining.length === 0) {
          this.updateGroupsAndContinue();
        } else {
          if (suggestedType) {
            this.typeWasSet(
              this.props.model.selectedDocument,
              suggestedType.value,
              suggestedType.name
            );
          }
        }
      } else {
        this.clearGroupingErrors();
      }
    });
    __publicField(this, "possibleManualGroupingButton", () => {
      if (groupingErrorExists(this.props) && !this.props.documentIndexerService._allDocumentsHaveGroups()) {
        return /* @__PURE__ */ jsx(
          DisablingButton,
          {
            className: "button--progress right " + bem("__update-and-continue-button"),
            disabled: this.state.updating,
            disabledText: "Saving...",
            onClick: this.clearGroupingErrors,
            children: "Group Manually"
          }
        );
      }
    });
    __publicField(this, "possibleSkipAutoGroupingButton", () => {
      if (this.props.documentIndexerService._allDocumentsHaveTypes() && this.props.documentIndexerService._allDocumentsHaveGroups()) {
        return /* @__PURE__ */ jsx(
          DisablingButton,
          {
            className: "button--progress right " + bem("__update-and-continue-button") + " " + bem("__skip-auto-grouping-button"),
            disabled: this.state.updating,
            disabledText: "Saving...",
            onClick: this.clearGroupingErrors,
            children: "Continue"
          }
        );
      }
    });
    __publicField(this, "clearGroupingErrors", () => {
      const ids = _.map(documentsWithGroupingErrors(this.props), (d) => d.id);
      if (ids.length > 0) {
        this.setState({ updating: true });
        this.props.documentIndexerService.clearGroupingErrors(ids).then(this.advanceStep).catch(() => {
          this.setState({ updating: false });
        });
      } else {
        this.advanceStep();
      }
    });
    __publicField(this, "doneButton", () => {
      return /* @__PURE__ */ jsx(
        "button",
        {
          className: "button--progress right " + bem("__update-and-continue-button") + " " + bem("__skip-auto-grouping-button"),
          onClick: this.clearGroupingErrors,
          children: "Continue Without Updating Groups"
        }
      );
    });
    __publicField(this, "updateGroupingButton", () => {
      if (this.props.documentIndexerService._allDocumentsHaveTypes()) {
        if (this.state.doctypeChanged || !this.props.documentIndexerService._allDocumentsHaveGroups()) {
          return /* @__PURE__ */ jsx(
            DisablingButton,
            {
              className: "button--progress right " + bem("__update-and-continue-button"),
              disabled: this.state.updating,
              disabledText: "Saving...",
              onClick: this.updateGroupsAndContinue,
              children: "Update Grouping"
            }
          );
        }
      } else {
        var docs = this.props.model.allDocuments();
        var remaining = _.reject(docs, _.property("type"));
        var d = remaining.length == 1 ? "Document" : "Documents";
        return /* @__PURE__ */ jsxs("button", { className: "button", disabled: true, children: [
          "(",
          remaining.length,
          ") ",
          d,
          " Remaining",
          " "
        ] });
      }
    });
    // Need to differentiate here if the type is set for proofOfDelivery/postal
    // then we need to do things special.
    __publicField(this, "typeWasSet", (document, type, type_name) => {
      if (!document.data.podFlagSetByUser) {
        document.is_pod = _.contains(["proofOfDelivery", "postal"], type) && !Api.Account.currentSettings().only_manual_pod;
        document.data.includesPOD = document.is_pod;
      }
      document.type = type;
      document.type_name = type_name;
      var types = this.state.types;
      types[document.id] = type;
      this.setState({ types, doctypeChanged: true });
      var doc = this.props.model.nextIncompleteDocument();
      if (doc && !this.props.stayOnPageAfterSetting) {
        this.props.model.selectPage(doc.pages[0]);
      }
      this.props.onUpdate(document, type);
    });
    __publicField(this, "updateGroupsAndContinue", () => {
      if (groupsWereManuallyRegrouped(this.props) || this.props.documentIndexerService._hiddenDocumentsExist()) {
        const dialogue = ["Are you sure you would like to re-run grouping?"];
        if (groupsWereManuallyRegrouped(this.props)) {
          dialogue.push(
            "You have manually edited groups via the 'Group Documents' step. Re-grouping will permanently revert those changes."
          );
        }
        if (this.props.documentIndexerService._hiddenDocumentsExist()) {
          dialogue.push(
            "You have hidden documents in the batch. Re-grouping will permanently delete the hidden documents."
          );
        }
        const confirmed = confirm(dialogue.join("\n\n"));
        if (!confirmed) {
          return;
        }
      }
      this.setState({ updating: true });
      if (this.props.isForced) {
        var page = this.state.prevSelectedDocument.pages[0];
        this.props.model.selectPage(page);
      } else {
        this.props.model.selectPage(null);
      }
      this.props.documentIndexerService.updateDocumentGroups(this.props.documentBatch.id).then(this.advanceStep).catch(() => {
        this.setState({
          updating: false
        });
      });
    });
    __publicField(this, "advanceStep", () => {
      this.props.onComplete();
      if (this.mounted) {
        this.setState({ updating: false, types: {} });
      }
      return null;
    });
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  render() {
    return /* @__PURE__ */ jsx(WaitingSpinner, { when: this.state.updating, children: /* @__PURE__ */ jsxs("div", { className: bem("__container"), children: [
      /* @__PURE__ */ jsxs("h3", { className: bem("__main-heading"), children: [
        "Identify The Documents ",
        this.completionButtons(),
        groupByAttachmentsButton(this.props)
      ] }),
      possibleGroupingFailures(this.props),
      this.selector()
    ] }) });
  }
  componentDidMount() {
    this.mounted = true;
    if (groupingErrorExists(this.props)) {
      const doc = documentsWithGroupingErrors(this.props)[0];
      this.props.model.selectPage(doc.pages[0]);
    }
  }
}
